module.exports = __webpack_public_path__ + "static/media/line.37c2a336.svg";